import "./App.css";
import "./i18n/config";

import ThreeFiber from "./components/three-fiber";
import AppContextProvider from "./contexts/app";
import { Suspense } from "react";
import Loading from "./components/elements/Loading";
import ContentDrawer from "./components/elements/Drawer";
import Menu from "./components/elements/Menu";
import Navbar from "./components/elements/Navbar";
import SectionContextProvider from "./contexts/sections";

function App() {
  return (
    <SectionContextProvider>
      <AppContextProvider>
        <Suspense fallback={<Loading />}>
          <ThreeFiber />
        </Suspense>
        <Navbar />
        <ContentDrawer />
        <Menu />
      </AppContextProvider>
    </SectionContextProvider>
  );
}

export default App;
